import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../contexts/UserContext';
interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [activeHash, setActiveHash] = useState(window.location.hash);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = useState([]);
  const {
    user, _logout
  } = useUserContext();

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // const handleLogout = async () => {
  //   try {
  //     // Call the backend logout endpoint
  //     await fetch(`${process.env.REACT_APP_SERVER_URL}/logout`, {
  //       method: 'POST',
  //       credentials: 'include', // Include cookies in the request
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     });
  //     Cookies.remove('gsccookie');
  //     // Clear any client-side storage
  //     localStorage.removeItem('userToken');
  //     localStorage.removeItem('dashboardCoinsData');
  //     localStorage.removeItem('dashboardCoinsTimestamp');

  //     // Redirect to login page
  //     window.location.href = '/login';
  //   } catch (error) {
  //     console.error('Logout failed:', error);
  //   }
  // };



  return (
    <div className="flex h-screen">
      {/* Sidebar/Drawer */}
      <div
        className={`bg-gray-800 bg-opacity-95 fixed inset-y-0 left-0 z-40 w-32 transform transition-transform duration-300 ease-in-out ${drawerOpen ? 'translate-x-0' : '-translate-x-full'} md:relative md:translate-x-0 shadow-lg`}
      >
        <div className="flex h-16 items-center justify-center border-b border-gray-700">
          <h1 className="text-xl font-bold text-white text-center">
            <img
              src="logo-white.png"
              alt="Logo"
              className="h-8 w-8 mr-2 inline-block"
              onError={e => (e.currentTarget.src = 'fallback-logo.png')}
            />
          </h1>
        </div>
        <nav className="mt-5">
          <ul>
            {user?.userType == "ADMIN" ? (
              [
                { text: 'Signals', path: '/dashboard' },
                { text: 'Trades', path: '/bot' },
                { text: 'Pre-Signals', path: '/prewatchers' },
                { text: 'Mean Theory', path: '/meantheory' },
                { text: 'Profile', path: '/profile' },
              ].map(item => {
                return (
                  <li key={item.text}
                    className={`flex mb-2 w-full items-center px-4 py-2 text-left text-white hover:bg-primary-light}`}
                    style={{
                      borderRadius: 5,
                    }}
                    onClick={() => {
                      navigate(item.path);
                      setDrawerOpen(false);
                      setActiveHash(window.location.hash);
                    }}
                  >
                    <p className="ml-1 text-md"
                      style={{
                        color: ("#" + item.path) == activeHash ? '#2563eb' : undefined,
                        fontWeight: ("#" + item.path) == activeHash ? 'bold' : undefined,
                      }}>
                      {item.text}
                    </p>

                  </li>
                );
              })) : (
              [
                { text: 'Signals', path: '/dashboard' },
                { text: 'Trades', path: '/bot' },
                { text: 'Profile', path: '/profile' },
              ].map(item => {
                return (
                  <li key={item.text}
                    className={`flex mb-2 w-full items-center px-4 py-2 text-left text-white hover:bg-primary-light}`}
                    style={{
                      borderRadius: 5,
                    }}
                    onClick={() => {
                      navigate(item.path);
                      setDrawerOpen(false);
                      setActiveHash(window.location.hash);
                    }}
                  >
                    <p className="ml-1 text-md"
                      style={{
                        color: ("#" + item.path) == activeHash ? '#2563eb' : undefined,
                        fontWeight: ("#" + item.path) == activeHash ? 'bold' : undefined,
                      }}>
                      {item.text}
                    </p>

                  </li>
                );
              }))}
            <li className="mt-3">
              <button
                style={{ borderRadius: 5 }}
                onClick={async () => {
                  setDrawerOpen(false);
                  const result = await _logout();
                  // if(result==1) {
                  //  // navigate('/login');
                  //  window.location.href = '/login'
                  // }
                }}
                className="flex w-full items-center px-4 py-2 text-left text-white hover:bg-primary-dark"
              >
                <span className="ml-1 text-xs">Logout</span>
              </button>
            </li>
          </ul>
        </nav>
      </div>

      {/* Main Content */}
      <div className="flex flex-1 flex-col">
        {/* Header */}
        <header className="bg-background-paper shadow">
          <div className="flex h-16 items-center justify-between px-4">
            {/* Add hamburger menu button to header for mobile */}
            <div className="flex items-center">
              <button
                onClick={() => setDrawerOpen(!drawerOpen)}
                className="rounded p-2 mr-2 bg-gray-800 text-white hover:bg-gray-700 md:hidden z-50"
                aria-label={drawerOpen ? 'Close menu' : 'Open menu'}
              >
                {drawerOpen ? (
                  <svg
                    className="h-6 w-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                ) : (
                  <svg
                    className="h-6 w-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                )}
              </button>
              {/* <h3 className="text-sm font-bold text-white">{process.env.REACT_APP_DISPLAYNAME}</h3> */}
            </div>
            <div>{/* Additional header content can go here */}</div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 p-4">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
